<template>
  <iframe
    class="Map"
    :src="this.locationUrl"
    height="450px"
    width="100%"
    style="border:0;"
    allowfullscreen=""
    loading="lazy">
  </iframe>
</template>

<script>

export default {
  name: 'Map',
  props: {
    locationUrl: String,
  },
};
</script>

<style lang="sass">
  @import './Map.sass'
</style>
